<template lang='pug'>
  bionic-metrics-chart.rounded-bottom(v-if='chartOptions' :options='chartOptions' :height='height')
</template>

<script>
import {get} from 'lodash';
import BionicMetricsChart from './Chart';

export default {
  name: 'BionicMetricsSummaryChart',
  components: {BionicMetricsChart},
  props: {
    total: {
      type: Number,
      default: 0
    },
    passing: {
      type: Number,
      default: 0
    },
    failing: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 20
    }
  },
  mounted() {
    this.load();
  },
  computed: {
    noData() {
      return this.total - (this.passing + this.failing);
    },
    height() {
      return `${this.size}px`;
    },
    dark() {
      return this.$vuetify.theme.dark;
    },
    greenColor() {
      const theme = this.dark ? 'dark' : 'light';
      return get(this.$vuetify, `theme.themes.${theme}.success.base`, '#00C853');
    }
  },
  methods: {
    load() {
      const series = [{
        barWidth: this.size,
        name: 'Passing',
        type: 'bar',
        stack: 'this',
        data: [{
          name: 'Passing',
          itemStyle: {color: this.greenColor},
          value: this.passing,
          tt: `${this.passing} Passing`
        }]
      }, {
        barWidth: this.size,
        name: 'Passing',
        type: 'bar',
        stack: 'this',
        data: [{
          name: 'Passing',
          itemStyle: {color: '#D84315'},
          value: this.failing,
          tt: `${this.failing} Failing`
        }]
      }, {
        barWidth: this.size,
        name: 'Passing',
        type: 'bar',
        stack: 'this',
        data: [{
          name: 'Passing',
          itemStyle: {color: '#CFD8DC'},
          value: !this.total ? 1 : this.noData,
          tt: `${this.noData} No Results`
        }]
      }];
      const max = this.total;
      this.chartOptions = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          // https://echarts.apache.org/en/option.html#tooltip.formatter
          formatter(params) {
            return params.data.tt;
          },
          position(point) {
            return [point[0] - 50, 25];
          }
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        xAxis: {
          show: false,
          type: 'value',
          max
        },
        yAxis: {
          show: false,
          type: 'category'
        },
        series
      };
    }
  },
  data() {
    return {
      chartOptions: null
    };
  }
};
</script>

<style lang='scss'>
  .rounded-bottom {
    canvas {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
</style>
